module.exports = __webpack_public_path__ + "static/media/Loading.9a0e80f3.png";